import React from 'react';
import i18n from '../../i18n';
import { IconUser } from '../Icon';
import { NavItem, NavItemIcon, NavItemLinkButton } from './styles';

declare global {
  interface Window {
    _imbox?: {
      push: (args: string[]) => void;
    };
  }
}

const ChatToggleButton = () => {
  const handleChatToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window._imbox) {
      window._imbox.push(['toggle']);
    }
  };

  return (
    <NavItem>
      <NavItemLinkButton href="#" onClick={handleChatToggle}>
        <NavItemIcon>
          <IconUser $outlined size="24px" />
        </NavItemIcon>
        {i18n.t('navigation_help_title')}
      </NavItemLinkButton>
    </NavItem>
  );
};

export default ChatToggleButton;
